module.exports = __webpack_public_path__ + "img/star-citizen-1920.368ba320.jpg";